<template>
	<VitePwaManifest />
	<NuxtLayout>
		<!-- <Transition> -->
		<NuxtPage class="h-100" style="min-height: 200px;" />
		<!-- </Transition> -->
	</NuxtLayout>

	<!-- <ClientOnly fallback-tag="span" fallback=""> -->

	<Teleport to="body">
		<div class="Modal__Box">
			<Loading :routerShow="routershow"></Loading>
			<AlertBox />
			<WarningModal></WarningModal>
		</div>
		<BaseDebug />
		<!-- <UpdateSw v-if="$pwa.needRefresh"></UpdateSw> -->
	</Teleport>

	<!-- </ClientOnly> -->
</template>
<script lang="ts" setup>
	import useUser from "~/store/UserInfo";
	import usePub from "~/store/Public";
	import dayjs from "dayjs";
	import relativeTime from "dayjs/plugin/relativeTime";
	import "dayjs/locale/zh-tw";

	import _ from "lodash";

	const intervalMS = 60 * 1000;
	const { ssrContext, $pwa } = useNuxtApp();
	const refer = ref({
		show: false,
	});
	if (!ssrContext) {
		if ("Notification" in window) {
			// 請求通知權限
			Notification.requestPermission().then(function (permission) {
				if (permission === "granted") {
					console.log("使用者已允許通知");
				} else {
					console.log("使用者拒絕通知");
				}
			});
		} else {
			console.log("此瀏覽器不支援通知");
		}
		// const { registerSW } = await import("virtual:pwa-register");
		// const updateSW = registerSW({
		// 	immediate: true,
		// 	onNeedRefresh() {
		// 		console.log("Refresh");
		// 	},
		// 	onRegisteredSW(swUrl: any, r: any) {
		// 		console.log(swUrl);
		// 		if (r) {
		// 			nextTick(async () => {
		// 				if (!(!r.installing && navigator)) return;

		// 				if ("connection" in navigator && !navigator.onLine) return;

		// 				const resp = await fetch(swUrl, {
		// 					cache: "no-store",
		// 					headers: {
		// 						cache: "no-store",
		// 						"cache-control": "no-cache",
		// 					},
		// 				});

		// 				if (resp?.status === 200) await r.update();
		// 			});
		// 		}
		// 		// r &&
		// 		// 	setInterval(async () => {
		// 		// 		if (!(!r.installing && navigator)) return;
		// 		// 		if ("connection" in navigator && !navigator.onLine) return;
		// 		// 		const resp = await fetch(swUrl, {
		// 		// 			cache: "no-store",
		// 		// 			headers: {
		// 		// 				cache: "no-store",
		// 		// 				"cache-control": "no-cache",
		// 		// 			},
		// 		// 		});
		// 		// 		if (resp?.status === 200) await r.update();
		// 		// 	}, intervalMS);
		// 	},
		// 	onOfflineReady() { },
		// });
		// updateSW();

		// const toast = useToast();
		onMounted(() => {
			// if ($pwa.offlineReady) {
			// 	console.log("App ready to work offline");
			// }
		});
		var u: string = navigator.userAgent,
			ua: string = navigator.userAgent.toLowerCase() ?? "",
			isLineApp: boolean = u.indexOf("Line") > -1, // Line 內建瀏覽器
			isFbApp: boolean = u.indexOf("FBAV") > -1, // FB App 內建瀏覽器
			isWeixinApp: boolean = ua.match(/MicroMessenger/i) == "micromessenger"; // 微信內建瀏覽器

		// 如果是 Line 內建瀏覽器
		if (isLineApp) {
			// do sth

			const query: any = useRoute().query ?? {};
			if (!query.openExternalBrowser) {
				query.openExternalBrowser = 1;
			}
			const redata = {
				name: useRoute().name,
				params: useRoute().params,
				query: query,
			};
			const routeData = useRouter().resolve(redata);
			window.location.href = routeData.href;
			console.log(routeData.href);
		}
		// 如果是 FB App 內建瀏覽器
		if (isFbApp) {
			// do sth
		}

		// 如果是 微信內建瀏覽器
		if (isWeixinApp) {
			// do sth
		}
	}
	const code = "v1.0.1";
	console.log(code);
	dayjs.extend(relativeTime);
	dayjs.locale(usePub().getSelectLang);
	usePub().loadData();
	try {
		if (useRoute().name.search("Leader") == -1) {
			await useUser().getBaseUser();
		}
	} catch (e) {}
	// useRouter().beforeResolve(() => {
	// 	usePub().loading = true;
	// });
	const nuxtApp = useNuxtApp();
	await usePub().getCompanyInfo();

	const companyInfo = computed({
		get() {
			return usePub().companyInfo;
		},
		set() {},
	});

	const routershow = ref(false);
	nuxtApp.hook("page:start", () => {
		routershow.value = true;
	});
	nuxtApp.hook("page:finish", () => {
		setTimeout(() => {
			routershow.value = false;
		}, 500);
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});

	const observer = new MutationObserver((mutations) => {
		_.each(mutations, (item) => {
			_.each(item.target.querySelectorAll("img"), (imageList) => {
				const temp = imageList.src;
				if (temp.indexOf("/image/noimage.jpg") > -1) {
					return;
				}
				imageList.onload = () => {};
				imageList.onerror = () => {
					imageList.src = "/image/noimage.jpg";
				};
			});
		});
	});

	const body = document.body;
	observer.observe(body, {
		childList: true,
		attributeFilter: ["img"],
	});
	useRouter().beforeEach(async (to, from) => {
		// await usePub().cancelAllFetch();
	});
	const color = ref({
		blur: "#2374d1",
		// teal: "#3c5353",
		teal: "green",
		// #14babb
		// #2374d1
	});
	const hexToRgb = (hex: string) => {
		// 檢查是否為三位數格式 (例如: #666)
		const isShorthand = hex.length === 4;

		let r, g, b;

		if (isShorthand) {
			// 擴展為六位數格式 (例如: #666 -> #666666)
			r = parseInt(hex[1] + hex[1], 16);
			g = parseInt(hex[2] + hex[2], 16);
			b = parseInt(hex[3] + hex[3], 16);
		} else {
			// 處理六位數格式 (例如: #666666)
			r = parseInt(hex.substring(1, 3), 16);
			g = parseInt(hex.substring(3, 5), 16);
			b = parseInt(hex.substring(5, 7), 16);
		}

		return [r, g, b];
	};
	const teal = "#14babb";
	const root = document.documentElement;
	// root.style.setProperty("--bs-main", teal);
	// root.style.setProperty("--bs-main-rgb", hexToRgb(teal).join(","));
</script>
<style lang="scss">
	// Bootstrap
	@import "~/node_modules/bootstrap/scss/mixins/banner";
	@include bsBanner("");
	// scss-docs-start import-stack
	// Configuration
	@import "~/node_modules/bootstrap/scss/functions";
	// Color system

	// scss-docs-start color-variables
	$blue: #0a56ad !default;
	$indigo: #5e42fc !default;
	$purple: #6f42c1 !default;
	$pink: #d63384 !default;
	$red: #db2c52 !default;
	$orange: #fd7e14 !default;
	// $yellow:  #FFC600 !default;
	$yellow: #e0a800 !default;
	$green2: #5ec5b1 !default;
	$green: #00a88c !default;
	$teal: #14babb !default;
	$cyan: #4dc0ff !default;

	$yellow2: #ffffaa !default;
	// scss-docs-end color-variables

	// scss-docs-start gray-color-variables
	$white: #fff !default;
	// $gray-100: #f8f9fa !default;
	// 自訂一個淺灰
	$gray-100: #f5f5f5 !default;
	// 自訂end
	$gray-200: #e9ecef !default;
	$gray-300: #dee2e6 !default;
	$gray-400: #ced4da !default;
	$gray-500: #adb5bd !default;
	$gray-600: #6c757d !default;
	$gray-700: #495057 !default;
	$gray-800: #343a40 !default;
	$gray-900: #212529 !default;
	$black: #000 !default;
	// scss-docs-end gray-color-variables

	// fusv-disable
	// scss-docs-start gray-colors-map
	$grays: (
		"100": $gray-100,
		"200": $gray-200,
		"300": $gray-300,
		"400": $gray-400,
		"500": $gray-500,
		"600": $gray-600,
		"700": $gray-700,
		"800": $gray-800,
		"900": $gray-900,
	) !default;
	// scss-docs-end gray-colors-map
	// fusv-enable

	// fusv-disable
	// scss-docs-start docs-colors-map
	$blue-100: tint-color($blue, 80%) !default;
	$blue-200: tint-color($blue, 60%) !default;
	$blue-300: tint-color($blue, 40%) !default;
	$blue-400: tint-color($blue, 20%) !default;
	$blue-500: $blue !default;
	$blue-600: shade-color($blue, 20%) !default;
	$blue-700: shade-color($blue, 40%) !default;
	$blue-800: shade-color($blue, 60%) !default;
	$blue-900: shade-color($blue, 80%) !default;

	$indigo-100: tint-color($indigo, 80%) !default;
	$indigo-200: tint-color($indigo, 60%) !default;
	$indigo-300: tint-color($indigo, 40%) !default;
	$indigo-400: tint-color($indigo, 20%) !default;
	$indigo-500: $indigo !default;
	$indigo-600: shade-color($indigo, 20%) !default;
	$indigo-700: shade-color($indigo, 40%) !default;
	$indigo-800: shade-color($indigo, 60%) !default;
	$indigo-900: shade-color($indigo, 80%) !default;

	$purple-100: tint-color($purple, 80%) !default;
	$purple-200: tint-color($purple, 60%) !default;
	$purple-300: tint-color($purple, 40%) !default;
	$purple-400: tint-color($purple, 20%) !default;
	$purple-500: $purple !default;
	$purple-600: shade-color($purple, 20%) !default;
	$purple-700: shade-color($purple, 40%) !default;
	$purple-800: shade-color($purple, 60%) !default;
	$purple-900: shade-color($purple, 80%) !default;

	$pink-100: tint-color($pink, 80%) !default;
	$pink-200: tint-color($pink, 60%) !default;
	$pink-300: tint-color($pink, 40%) !default;
	$pink-400: tint-color($pink, 20%) !default;
	$pink-500: $pink !default;
	$pink-600: shade-color($pink, 20%) !default;
	$pink-700: shade-color($pink, 40%) !default;
	$pink-800: shade-color($pink, 60%) !default;
	$pink-900: shade-color($pink, 80%) !default;

	$red-100: tint-color($red, 80%) !default;
	$red-200: tint-color($red, 60%) !default;
	$red-300: tint-color($red, 40%) !default;
	$red-400: tint-color($red, 20%) !default;
	$red-500: $red !default;
	$red-600: shade-color($red, 20%) !default;
	$red-700: shade-color($red, 40%) !default;
	$red-800: shade-color($red, 60%) !default;
	$red-900: shade-color($red, 80%) !default;

	$orange-100: tint-color($orange, 80%) !default;
	$orange-200: tint-color($orange, 60%) !default;
	$orange-300: tint-color($orange, 40%) !default;
	$orange-400: tint-color($orange, 20%) !default;
	$orange-500: $orange !default;
	$orange-600: shade-color($orange, 20%) !default;
	$orange-700: shade-color($orange, 40%) !default;
	$orange-800: shade-color($orange, 60%) !default;
	$orange-900: shade-color($orange, 80%) !default;

	$yellow-100: tint-color($yellow, 80%) !default;
	$yellow-200: tint-color($yellow, 60%) !default;
	$yellow-300: tint-color($yellow, 40%) !default;
	$yellow-400: tint-color($yellow, 20%) !default;
	$yellow-500: $yellow !default;
	$yellow-600: shade-color($yellow, 20%) !default;
	$yellow-700: shade-color($yellow, 40%) !default;
	$yellow-800: shade-color($yellow, 60%) !default;
	$yellow-900: shade-color($yellow, 80%) !default;

	$green-100: tint-color($green, 80%) !default;
	$green-200: tint-color($green, 60%) !default;
	$green-300: tint-color($green, 40%) !default;
	$green-400: tint-color($green, 20%) !default;
	$green-500: $green !default;
	$green-600: shade-color($green, 20%) !default;
	$green-700: shade-color($green, 40%) !default;
	$green-800: shade-color($green, 60%) !default;
	$green-900: shade-color($green, 80%) !default;

	$teal-100: tint-color($teal, 80%) !default;
	$teal-200: tint-color($teal, 60%) !default;
	$teal-300: tint-color($teal, 40%) !default;
	$teal-400: tint-color($teal, 20%) !default;
	$teal-500: $teal !default;
	$teal-600: shade-color($teal, 20%) !default;
	$teal-700: shade-color($teal, 40%) !default;
	$teal-800: shade-color($teal, 60%) !default;
	$teal-900: shade-color($teal, 80%) !default;

	$cyan-100: tint-color($cyan, 80%) !default;
	$cyan-200: tint-color($cyan, 60%) !default;
	$cyan-300: tint-color($cyan, 40%) !default;
	$cyan-400: tint-color($cyan, 20%) !default;
	$cyan-500: $cyan !default;
	$cyan-600: shade-color($cyan, 20%) !default;
	$cyan-700: shade-color($cyan, 40%) !default;
	$cyan-800: shade-color($cyan, 60%) !default;
	$cyan-900: shade-color($cyan, 80%) !default;

	// scss-docs-start docs-colors-map
	// fusv-enable

	$webMainInput: #f6f7ff !default;
	$webMain: $teal !default;
	$webMainLight: $green-200 !default;
	$webMainBorder: $green-600 !default;
	// $webMainInput: #F7FCFB !default;
	$webSub: #ff8469 !default;
	$webSubLight: #ffede4 !default;
	$webHashTag: #45bbff !default;
	$webBlue: $blue-400 !default;
	$webGreen: $teal !default;
	$webHGray: #a3a3a3 !default;
	$webMGray: #c4c4c4 !default;
	$webLGray: #f1f1f1 !default;
	$webDark: #333 !default;
	$deepred: rgb(168, 0, 0);
	// scss-docs-start colors-map
	$colors: (
		"blue": $blue,
		"indigo": $indigo,
		"purple": $purple,
		"pink": $pink,
		"red": $red,
		"orange": $orange,
		"yellow": $yellow,
		"green": $green,
		"teal": $teal,
		"cyan": $cyan,
		"black": $black,
		"white": $white,
		"gray": $gray-600,
		"gray-dark": $gray-800,
		// custom color
			"main": $webMain,
		"main-light": $webMainLight,
		"main-border": $webMainBorder,
		"main-input": $webMainInput,
		"sub": $webSub,
		"sub-light": $webSubLight,
		"hash-tag": $webHashTag,
		"m-blue": $webBlue,
		"m-green": $webGreen,
		"m-h-gray": $webHGray,
		"m-m-gray": $webMGray,
		"m-l-gray": $webLGray,
		"m-dark": $webDark,
		"deepred": $deepred,
		// custom color
	) !default;
	// scss-docs-end colors-map

	// The contrast ratio to reach against white, to determine if color changes from "light" to "dark". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.
	// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast
	$min-contrast-ratio: 4.5 !default;

	// Customize the light and dark text colors for use in our color contrast function.
	$color-contrast-dark: $black !default;
	$color-contrast-light: $white !default;

	// @import "../node_modules/bootstrap/scss/bootstrap";
	/*
 * Silicon | Multipurpose Bootstrap 5 Template & UI Kit
 * Copyright 2022 Createx Studio
 * Theme styles
*/

	// User variables

	// @import '../node_modules/bootstrap/scss/functions';
	// Configuration & utilities

	@import "~/style/variables";
	@import "~/style/variables-dark";
	@import "~/style/user-variables";

	// @import "~/node_modules/bootstrap/scss/variables";
	// @import "~/node_modules/bootstrap/scss/variables-dark";
	@import "~/node_modules/bootstrap/scss/maps";
	@import "~/node_modules/bootstrap/scss/mixins";
	@import "~/style/utilities";
	// @import "utilities";

	// Layout & components
	@import "~/node_modules/bootstrap/scss/root";
	@import "~/style/reboot";
	// @import "reboot";
	@import "~/node_modules/bootstrap/scss/type";
	@import "~/node_modules/bootstrap/scss/images";
	@import "~/node_modules/bootstrap/scss/containers";
	@import "~/node_modules/bootstrap/scss/grid";
	@import "~/node_modules/bootstrap/scss/tables";
	@import "~/node_modules/bootstrap/scss/forms";
	@import "~/node_modules/bootstrap/scss/buttons";
	@import "~/node_modules/bootstrap/scss/transitions";
	@import "~/node_modules/bootstrap/scss/dropdown";
	@import "~/node_modules/bootstrap/scss/button-group";
	@import "~/node_modules/bootstrap/scss/nav";
	@import "~/node_modules/bootstrap/scss/navbar";
	@import "~/node_modules/bootstrap/scss/card";
	@import "~/node_modules/bootstrap/scss/accordion";
	@import "~/node_modules/bootstrap/scss/breadcrumb";
	@import "~/node_modules/bootstrap/scss/pagination";
	@import "~/node_modules/bootstrap/scss/badge";
	@import "~/node_modules/bootstrap/scss/alert";
	@import "~/node_modules/bootstrap/scss/progress";
	@import "~/node_modules/bootstrap/scss/list-group";
	@import "~/node_modules/bootstrap/scss/close";
	@import "~/node_modules/bootstrap/scss/toasts";
	@import "~/node_modules/bootstrap/scss/modal";
	@import "~/node_modules/bootstrap/scss/tooltip";
	@import "~/node_modules/bootstrap/scss/popover";
	@import "~/node_modules/bootstrap/scss/carousel";
	@import "~/node_modules/bootstrap/scss/spinners";
	@import "~/node_modules/bootstrap/scss/offcanvas";
	@import "~/node_modules/bootstrap/scss/placeholders";

	// Helpers
	@import "~/node_modules/bootstrap/scss/helpers";

	// Utilities
	@import "~/node_modules/bootstrap/scss/utilities/api";
	// scss-docs-end import-stack

	// Layout & componentss
	// @import 'reboot';
	// @import 'components';

	// Dark mode
	// @import 'dark-mode';
	// User custom styles
	@import "~/style/user";
	@import "~/node_modules/@vuepic/vue-datepicker/dist/main.css";
</style>
